import * as o from "react";
import m from "../lib/IconBase.es.js";
import e from "../defs/FilmStrip.es.js";
const r = o.forwardRef((t, i) => /* @__PURE__ */ o.createElement(m, { ref: i, ...t, weights: e }));
r.displayName = "FilmStripIcon";
const c = r;
export {
  c as FilmStrip,
  r as FilmStripIcon
};
